import { IconTypesSchema } from "../../../skins/common/icons";
export const isValidIcon = (iconName) => IconTypesSchema.safeParse(iconName).success;
//# sourceMappingURL=helpers.js.map